import { render } from "./SwitchToggle.vue?vue&type=template&id=f4808042&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"

import "./SwitchToggle.vue?vue&type=style&index=0&id=f4808042&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4808042"]])

export default __exports__